import { render } from "./AddBlacklist.vue?vue&type=template&id=2705c1c5&scoped=true"
import script from "./AddBlacklist.vue?vue&type=script&lang=js"
export * from "./AddBlacklist.vue?vue&type=script&lang=js"

import "./AddBlacklist.vue?vue&type=style&index=0&id=2705c1c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2705c1c5"]])

export default __exports__